import React from "react";
import { Box, Tooltip, Typography } from "@material-ui/core";
import { getLanguageSoundInfo } from "../utils/languageSoundGlossary";

export default function LanguageSoundHeader({
  code,
  isTeacher,
  className,
  children,
}) {
  const info = isTeacher ? getLanguageSoundInfo(code) : null;
  const label = children ?? code;

  if (!info) {
    return <span className={className}>{label}</span>;
  }

  return (
    <Tooltip
      arrow
      enterDelay={200}
      title={
        <Box style={{ maxWidth: 280, padding: "2px 0" }}>
          <Typography style={{ fontWeight: 700, fontSize: 13, lineHeight: 1.35 }}>
            {info.fullForm}
          </Typography>
          <Typography style={{ fontSize: 12, lineHeight: 1.5, marginTop: 6, opacity: 0.95 }}>
            {info.explanation}
          </Typography>
        </Box>
      }
    >
      <span className={className} style={{ cursor: "help" }}>
        {label}
      </span>
    </Tooltip>
  );
}
